import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Skeleton from '@mui/material/Skeleton';
import { alpha } from '@mui/material/styles';
import { t } from 'i18next';

import useAccountQuery from '~queries/useAccountQuery';
import { Nullable } from '~types/Nullable';

interface CustomerAccountNotesProps {
  accountId?: Nullable<string>;
  companyId?: Nullable<string>;
}

export function CustomerAccountNotes({
  accountId,
  companyId,
}: CustomerAccountNotesProps) {
  const { account, isLoading } = useAccountQuery(accountId, companyId);
  const notes = account?.notes;

  if (isLoading) {
    return (
      <Grid size={{ xs: 12 }}>
        <Skeleton variant="rounded" data-test-id="customer-account-notes-loading" />
      </Grid>
    );
  }

  if (!notes?.trim()) {
    return null;
  }

  return (
    <Grid size={{ xs: 12 }}>
      <Alert
        severity="info"
        data-test-id="customer-account-notes"
        sx={(theme) => ({
          bgcolor: alpha(theme.palette.info.main, 0.16),
          border: `1px solid ${alpha(theme.palette.info.main, 0.5)}`,
          color: 'text.primary',
        })}
      >
        <AlertTitle>{t('dispatch.order.customer_account_notes')}</AlertTitle>
        {/* 7em is about five lines at the Alert's 1.43 line height. */}
        <Box sx={{ maxHeight: '7em', overflowY: 'auto', whiteSpace: 'pre-wrap' }}>
          {notes}
        </Box>
      </Alert>
    </Grid>
  );
}
